<template>
  <svg width="16"
       height="20"
       viewBox="0 0 16 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M3.31543 19.1816H12.6846C14.5742 19.1816 15.5498 18.1885 15.5498 16.29V8.30957C15.5498 7.0791 15.3916 6.5166 14.627 5.73438L10.0303 1.06738C9.2832 0.311523 8.66797 0.135742 7.56055 0.135742H3.31543C1.43457 0.135742 0.450195 1.12891 0.450195 3.03613V16.29C0.450195 18.1885 1.43457 19.1816 3.31543 19.1816ZM3.46484 17.4238C2.62109 17.4238 2.19922 16.9844 2.19922 16.1758V3.1416C2.19922 2.3418 2.62109 1.89355 3.47363 1.89355H7.2002V6.6748C7.2002 7.94922 7.82422 8.56445 9.08984 8.56445H13.8008V16.1758C13.8008 16.9844 13.3789 17.4238 12.5264 17.4238H3.46484ZM9.25684 7.02637C8.8877 7.02637 8.72949 6.86816 8.72949 6.50781V2.12207L13.5635 7.02637H9.25684ZM11.0938 10.8672H4.74805C4.41406 10.8672 4.17676 11.1045 4.17676 11.4121C4.17676 11.7285 4.41406 11.9746 4.74805 11.9746H11.0938C11.4102 11.9746 11.6475 11.7285 11.6475 11.4121C11.6475 11.1045 11.4102 10.8672 11.0938 10.8672ZM11.0938 13.8027H4.74805C4.41406 13.8027 4.17676 14.0488 4.17676 14.3652C4.17676 14.6729 4.41406 14.9102 4.74805 14.9102H11.0938C11.4102 14.9102 11.6475 14.6729 11.6475 14.3652C11.6475 14.0488 11.4102 13.8027 11.0938 13.8027Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'DocumentIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
